export const inStrings = (query: string, values: string[]) => {
  return values.some((value) => {
    return value.includes(query);
  });
};
